import React, { useState } from "react";
import { Bar } from "react-chartjs-2";
import { Dropdown } from "react-bootstrap";
import { FiCalendar } from "react-icons/fi";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip
} from "chart.js";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip);

const chartData = {
  Monthly: [30,10,20,18,15,28,25],
  Weekly: [18,8,12,10,9,15,13],
  Yearly: [45,20,32,30,25,40,35]
};

export default function PayrollChart() {

  const [range, setRange] = useState("Monthly");

  const data = {
    labels: ["1","2","3","4","5","6","7"],

    datasets: [

      /* background bars */

      {
        data: [50,50,50,50,50,50,50],
        backgroundColor: "#edf1f5",
        borderRadius: 50,
        borderSkipped: false,
        barThickness: 8,
        order: 1
      },

      /* payroll bars */

      {
        label: "Payroll",
        data: chartData[range],
        backgroundColor: "#2f5d67",
        borderRadius: 50,
        borderSkipped: false,
        barThickness: 8,
        order: 2
      }

    ]
  };

  const options = {

    responsive: true,
    maintainAspectRatio: false,

    plugins: {

      legend: { display: false },

      tooltip: {
        backgroundColor: "#ffffff",
        titleColor: "#333",
        bodyColor: "#333",
        borderColor: "#e5e7eb",
        borderWidth: 1,
        padding: 10,
        displayColors: true,
        callbacks:{
          label:(ctx)=>` Payroll: ${ctx.raw}`
        }
      }

    },

    scales: {

      x: {
        grid: { display:false },
        ticks: { display:false },
        border: { display:false }
      },

      y: {
        grid: { display:false },
        ticks: { display:false },
        border: { display:false },
        suggestedMax:50
      }

    }

  };

  return (

    <div>

      {/* dropdown */}

      <Dropdown className="mb-2">

        <Dropdown.Toggle variant="light" className="border">
          <FiCalendar className="me-1"/> {range}
        </Dropdown.Toggle>

        <Dropdown.Menu>

          <Dropdown.Item onClick={()=>setRange("Monthly")}>
            Monthly
          </Dropdown.Item>

          <Dropdown.Item onClick={()=>setRange("Weekly")}>
            Weekly
          </Dropdown.Item>

          <Dropdown.Item onClick={()=>setRange("Yearly")}>
            Yearly
          </Dropdown.Item>

        </Dropdown.Menu>

      </Dropdown>

      {/* chart */}

      <div style={{width:"120px", height:"80px"}}>
        <Bar data={data} options={options}/>
      </div>

    </div>

  );
}